
/**
 * Full-page loading overlay — purple/blue gradient, double-ring spinner.
 * Drop-in replacement for every bare loading-overlay + loading-spinner pattern.
 *
 * Usage:
 *   import PageLoader from "../../components/common/PageLoader";
 *   if (loading) return <PageLoader message="Loading users…" />;
 */
const PageLoader = ({ message = "Loading…" }) => (
  <div className="loading-overlay">
    <div className="loading-spinner" />
    <p className="loading-msg">{message}</p>
  </div>
);

export default PageLoader;
